import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import Grow from '@mui/material/Grow';
import { useTheme } from '@mui/material/styles';

function NotFound() {
    const theme = useTheme();
    const [show, setShow] = React.useState(false);
    React.useEffect(() => {
        setShow(true);
    }, []);
    return (
        <Box
            sx={{
                minHeight: '60vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                mt: 10,
                animation: 'fadeIn 1s',
                background: theme.palette.background.default,
                color: theme.palette.text.primary,
            }}
        >
            <Grow in={show} timeout={900}>
                <Box
                    sx={{
                        color: theme.palette.accent.main,
                        mb: 2,
                        animation: 'bounce 1.2s infinite',
                        display: 'inline-flex',
                    }}
                >
                    <SentimentDissatisfiedIcon sx={{ fontSize: 80 }} />
                </Box>
            </Grow>
            <Typography variant="h2" component="h1" sx={{ fontWeight: 700, mb: 1, fontSize: { xs: '2rem', md: '2.5rem' }, color: theme.palette.primary.main }}>
                404 - Page Not Found
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, color: theme.palette.text.secondary }}>
                The page you are looking for does not exist.
            </Typography>
            <Button
                component={RouterLink}
                to="/"
                variant="contained"
                size="large"
                sx={{
                    borderRadius: '30px',
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.accent.main} 100%)`,
                    boxShadow: '0 4px 24px rgba(255,76,96,0.15)',
                    textTransform: 'none',
                    fontSize: '1rem',
                    color: theme.palette.primary.contrastText,
                    '&:hover': {
                        background: `linear-gradient(90deg, ${theme.palette.accent.main} 0%, ${theme.palette.primary.main} 100%)`,
                        transform: 'scale(1.05)',
                    },
                }}
            >
                Go to Home
            </Button>
            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-15px); }
                }
            `}</style>
        </Box>
    );
}

export default NotFound; 